import { FC } from 'react';
import { Card, Table, Empty } from 'antd';
import { MedicationAdmin } from '../../../../../models/admin/student-admin.model';

interface MedicationTabProps {
  medications: MedicationAdmin[];
}

const MedicationTab: FC<MedicationTabProps> = ({ medications }) => {
  const formatDate = (dateStr: string | null) => {
    if (!dateStr) return '-';
    return new Date(dateStr).toLocaleDateString();
  };

  const columns = [
    {
      title: 'Medication Name',
      dataIndex: 'medicationName',
      key: 'medicationName',
    },
    {
      title: 'Dosage',
      dataIndex: 'dosage',
      key: 'dosage',
      render: (dosage: string | null) => dosage || '-',
    },
    {
      title: 'Frequency',
      dataIndex: 'frequency',
      key: 'frequency',
      render: (frequency: string | null) => frequency || '-',
    },
    {
      title: 'Instructions',
      dataIndex: 'instructions',
      key: 'instructions',
      render: (instructions: string | null) => instructions || '-',
    },
    {
      title: 'Administered By',
      dataIndex: 'administeredBy',
      key: 'administeredBy',
      render: (administeredBy: string | null) => administeredBy || '-',
    },
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      key: 'startDate',
      render: (date: string | null) => formatDate(date),
    },
    {
      title: 'End Date',
      dataIndex: 'endDate',
      key: 'endDate',
      render: (date: string | null) => formatDate(date),
    },
  ];

  return (
    <Card title="Medication List">
      {medications.length > 0 ? (
        <Table
          dataSource={medications}
          columns={columns}
          rowKey="id"
          pagination={false}
          size="middle"
          scroll={{ x: true }}
        />
      ) : (
        <Empty description="No medications on file" />
      )}
    </Card>
  );
};

export default MedicationTab;
